import SearchInput, { SearchInputProps } from './SearchInput.component';

export type SearchInputType = SearchInputProps;

export default SearchInput;
